import React from 'react'

const NotFound = () => {
    return (
        <div>
            <h1>Oops no such resource ( 404 error )</h1>

            <img src='https://http.cat/404' alt='404'  />

        </div>
    )
}

export default NotFound
